import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"
import { rails_direct_uploads_path } from "../routes"

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["input", "form", "fileList"]
  static values = {
    groupId: String,
    resourceType: String,
    resourceId: String
  }

  browse(event) {
    event.preventDefault()
    // Clear the input value to allow selecting the same file again
    this.inputTarget.value = ""
    this.inputTarget.click()
  }

  async handleFiles(event) {
    event.preventDefault()
    
    const files = Array.from(this.inputTarget.files)
    
    if (files.length === 0) return
    
    this.totalFiles = files.length
    this.completedFiles = 0
    
    // Use the loading-bar controller
    this.showLoader()
    
    const uploadedFiles = []
    
    for (const file of files) {
      try {
        // Upload using DirectUpload
        const blob = await this.uploadWithDirectUpload(file)
        
        uploadedFiles.push({
          signed_id: blob.signed_id,
          filename: blob.filename,
          content_type: blob.content_type,
          group_id: this.groupIdValue || "0"
        })
        
        this.completedFiles++
      } catch (error) {
        console.error(`Failed to upload file: ${file.name}`, error)
      }
    }
    
    if (uploadedFiles.length > 0) {
      // Submit the uploaded file data to the server
      await this.submitUploadedFiles(uploadedFiles)
    }
    
    // Hide the loader and clear the file input
    setTimeout(() => {
      this.hideLoader()
    }, 1000)
    
    // Explicitly clear the input field so the same file can be selected again
    this.inputTarget.value = ''
  }

  async uploadWithDirectUpload(file) {
    return new Promise((resolve, reject) => {
      const upload = new DirectUpload(
        file,
        rails_direct_uploads_path(),
        this
      )

      upload.create((error, blob) => {
        if (error) {
          reject(error)
        } else {
          resolve(blob)
        }
      })
    })
  }
  
  // Inter-controller communication with loading-bar controller
  showLoader() {
    const loadingBarController = this.application.getControllerForElementAndIdentifier(
      document.getElementById('custom-loading-bar'),
      'loading-bar'
    )
    
    if (loadingBarController) {
      loadingBarController.showLoader()
    }
  }
  
  hideLoader() {
    const loadingBarController = this.application.getControllerForElementAndIdentifier(
      document.getElementById('custom-loading-bar'),
      'loading-bar'
    )
    
    if (loadingBarController) {
      loadingBarController.hideLoader()
    }
  }

  async submitUploadedFiles(uploadedFiles) {
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      
      const response = await fetch('/file_groups/upload_files', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          files: uploadedFiles,
          resource_type: this.resourceTypeValue,
          resource_id: this.resourceIdValue
        })
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const streamContent = await response.text()
      
      // Use Turbo API for clean DOM updates
      window.Turbo.renderStreamMessage(streamContent)
      
    } catch (error) {
      console.error('Error submitting files data:', error)
    }
  }
}
